import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { getDecodedBootstrappedLaunchDarklyFlags } from '../../global/splash/launch-darkly-init';
import { useMemo } from 'react';

export const useEnableNewHotkeySystem = (): boolean => {
  // because this is a flag that touches so many scary things (such as the app root) in such a deep way, we're electing to use the bootstrap values
  // instead of reacting in real-time to flag changes.
  const bootstrappedFlags = useMemo(() => getDecodedBootstrappedLaunchDarklyFlags() ?? {}, []);
  try {
    const value =
      bootstrappedFlags[FeatureFlagDeclarations.useNewHotkeySystem.key] ?? FeatureFlagDeclarations.useNewHotkeySystem.defaultValue;
    return value;
  } catch {
    return FeatureFlagDeclarations.useNewHotkeySystem.defaultValue;
  }
};
